import wx from "weixin-js-sdk";
import VueResource from 'vue-resource';
import Vue from 'vue'
Vue.use(VueResource);
export function wx_share(apiUrl,user,item){
    console.log(item);
    let linker = location.href.split("#")[0];
    var sharelink = "";
    if (user) {
        sharelink = location.href.split("#")[0] + "#" + location.href.split("#")[1].split("?")[0] + "?share=" + user.user.id;
    }
    else {
        sharelink = location.href.split("#")[0] + "#" + location.href.split("#")[1];
    }
    Vue.http
    .post(
          apiUrl + "weixin/public/getconfig",
          { url: linker },
          { params: {}, headers: {} }
    )
    .then((response) => {
          let data = response.body;
          let d = data.data;
          wx.config({
            debug: false,
            appId: d["appId"], // 必填，公众号的唯一标识
            timestamp: d["timestamp"], // 必填，生成签名的时间戳
            nonceStr: d["noncestr"], // 必填，生成签名的随机串
            signature: d["signature"], // 必填，签名
            jsApiList: ["updateAppMessageShareData",'updateTimelineShareData'], // 必填，需要使用的JS接口列表
          });
          wx.checkJsApi({
            jsApiList: ['updateAppMessageShareData','updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function() {
                // alert(JSON.stringify(res));

            // 以键值对的形式返回，可用的api值true，不可用为false
            // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            }
          });
          wx.ready(()=> {
            //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
              title: item.post_title, // 分享标题
              desc:  item.desc, // 分享描述
              //   link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              link: sharelink,
              imgUrl: item.thumbnail, // 分享图标
              success: function () {
                // 设置成功
                //   alert(JSON.stringify(res));
              }
                 
            });
            wx.updateTimelineShareData({
              title: item.post_title, // 分享标题
              link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:  item.thumbnail, // 分享图标
              success: function () {
                // 设置成功
              },
            });
          });
       }
    );
}
export default{
    wx_share
}